export enum SubscriptionPeriod {
    month = 'Month',
    quarter = 'Quarter',
    year = 'Year'
}
